import { render, staticRenderFns } from "./CampaignAttribution.vue?vue&type=template&id=7961d43a&"
import script from "./CampaignAttribution.vue?vue&type=script&lang=js&"
export * from "./CampaignAttribution.vue?vue&type=script&lang=js&"
import style0 from "./CampaignAttribution.vue?vue&type=style&index=0&id=7961d43a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports